import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import {RootState} from '../store';
import { EFaqsCategoryIcons } from './config';
import { TFAQsItem, TFAQsState } from './types';


export const buzzwordsIcon: EFaqsCategoryIcons = EFaqsCategoryIcons.BUZZWORDS;

const initialState: TFAQsState = [];

const faqSlice = createSlice({
    name: 'faq',
    initialState,
    reducers: {
        addQuestions: (state, action: PayloadAction<TFAQsItem[]>) => {
            action.payload.forEach(newItem => {
                const existingIndex = state.findIndex(item => item.id === newItem.id);
                
                if (existingIndex !== -1) {
                    state[existingIndex] = { ...state[existingIndex], ...newItem };
                } else {
                    state.push(newItem);
                }
            });
        },
    },
});


export const { addQuestions } = faqSlice.actions;

export const selectAllFAQs = (state: RootState) => state.faq;

export default faqSlice.reducer;
